function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../../../logger';
export var Ewma = /*#__PURE__*/ function() {
    "use strict";
    function Ewma(halfLife) {
        _class_call_check(this, Ewma);
        _define_property(this, "alpha", 0);
        _define_property(this, "estimate", 0);
        _define_property(this, "totalWeight", 0);
        _define_property(this, "logger", void 0);
        this.alpha = Math.exp(Math.log(0.5) / halfLife);
        this.logger = sdkLogger.withContext('Ewma Smoother');
    }
    _create_class(Ewma, [
        {
            key: "updateAlpha",
            value: function updateAlpha(halfLife) {
                if (halfLife <= 0) {
                    this.logger.warn('expected halfLife to be positive');
                }
                this.alpha = Math.exp(Math.log(0.5) / halfLife);
            }
        },
        {
            key: "sample",
            value: function sample(weight, bandwidth) {
                var adjAlpha = Math.pow(this.alpha, weight);
                var newEstimate = bandwidth * (1 - adjAlpha) + adjAlpha * this.estimate;
                if (!isNaN(newEstimate)) {
                    this.estimate = newEstimate;
                    this.totalWeight += weight;
                }
            }
        },
        {
            key: "getEstimate",
            value: function getEstimate() {
                var zeroFactor = 1 - Math.pow(this.alpha, this.totalWeight);
                return this.estimate / zeroFactor;
            }
        }
    ]);
    return Ewma;
}();

//# sourceMappingURL=ewma.js.map